"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "calci": {
    "39d3a4d1": [{
      "hkey": "c4f51c13",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "castel-maggiore": [{
      "hkey": "c4f51c13",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "calci"
    }],
    "c4733976": [{
      "hkey": "c4f51c13",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "il-colle": [{
      "hkey": "c4f51c13",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "calci"
    }],
    "0c1de87c": [{
      "hkey": "c4f51c13",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "la-corte": [{
      "hkey": "c4f51c13",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "calci"
    }],
    "c507c915": [{
      "hkey": "c4f51c13",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "la-pieve": [{
      "hkey": "c4f51c13",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0cd3c46f": [{
      "hkey": "9a9cfb65",
      "slug": "rezzano-nicosia",
      "name": "Rezzano-Nicosia",
      "primary": true,
      "skipSearch": false
    }],
    "rezzano": [{
      "hkey": "9a9cfb65",
      "slug": "rezzano-nicosia",
      "name": "Rezzano-Nicosia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c63e91b9": [{
      "hkey": "14dff5cb",
      "slug": "calci",
      "name": "Calci",
      "primary": true,
      "skipSearch": false
    }],
    "san-lorenzo": [{
      "hkey": "14dff5cb",
      "slug": "calci",
      "name": "Calci",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8ccf6d77": [{
      "hkey": "14dff5cb",
      "slug": "calci",
      "name": "Calci",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia": [{
      "hkey": "14dff5cb",
      "slug": "calci",
      "name": "Calci",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "45230ad5": [{
      "hkey": "c4f51c13",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "tre-colli": [{
      "hkey": "c4f51c13",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "calci"
    }]
  }
};
exports["default"] = _default;